export const clothesTranslations = {
  'athletic tracksuit with running shoes': 'Tuta Sportiva E Scarpe Da Corsa',
  'blazer with silk blouse and dress pants':
    'Blazer, Camicetta Di Seta E Pantaloni',
  blouse: 'Camicetta',
  'button-up shirt': 'Camicia Abbottonata',
  cardigan: 'Cardigan',
  'casual cardigan with corduroy pants': 'Cardigan E Pantaloni Di Velluto',
  'casual outfit with flowy blouse and tailored pants':
    'Outfit Con Camicetta E Pantaloni',
  'denim overalls with floral blouse and ankle boots':
    'Salopette E Camicetta A Fiori',
  'dress slacks': 'Pantaloni Eleganti',
  'elastic waist palazzo pants': 'Pantaloni Palazzo',
  'flannel tunic': 'Tunica Di Flanella',
  'formal blouse with vest and pencil skirt': 'Camicetta, Gilet E Gonna',
  'full suit with blouse and scarf': 'Completo, Camicetta E Sciarpa',
  jeans: 'Jeans',
  'knit sweater dress': 'Abito In Maglia',
  'long cardigan': 'Cardigan Lungo',
  'polo dress': 'Abito Polo',
  'ski jacket with insulated pants and ski boots': 'Giacca E Pantaloni Da Sci',
  sweater: 'Maglione',
  't-shirt': 'Maglietta manica corta',
  turtleneck: 'Dolcevita',
  'turtleneck sweater with a-line skirt': 'Dolcevita E Gonna A Trapezio',
  'tweed jacket with blouse and trousers': 'Giacca Tweed E Pantaloni',
  'wool coat': 'Cappotto elegante',
  'blazer with collared shirt and slacks': 'Blazer, Camicia E Pantaloni',
  'casual outfit with button-down shirt and khaki pants':
    'Outfit Con Camicia E Pantaloni Khaki',
  'casual sweater with corduroy pants': 'Maglione E Pantaloni Di Velluto',
  'elastic waist pants': 'Pantaloni Con Elastico',
  "farmer's overalls with plaid shirt and work boots":
    'Salopette E Camicia A Quadri',
  'flannel shirt': 'Camicia casual',
  'formal dress shirt with vest and dress pants': 'Camicia, Gilet E Pantaloni',
  'full suit with dress shirt and tie': 'Completo, Camicia E Cravatta',
  hoodie: 'Felpa',
  // 'knit sweater': 'Maglione a maglia',
  'polo shirt': 'Polo',
  'turtleneck sweater with dress pants': 'Dolcevita E Pantaloni Eleganti',
  'tweed sport coat with dress shirt and trousers': 'Giacca Tweed E Pantaloni',
  slacks: 'Pantaloni Eleganti',
  'jacket shirt and tie': 'Giacca e cravatta',
  'jacket and shirt': 'Giacca e camicia',
  'short sleeve t-shirt': 'Maglia manica corta',
  'long sleeve t-shirt': 'Maglia manica lunga',
  // sweatshirt: 'Maglione casual',
  'shirt and sweater': 'Maglione e camicia',
  'solid color shirt': 'Camicia a tinta unita',
  'striped shirt': 'Camicia a strisce',
};

export const colorTranslations = {
  beige: {
    it: 'Beige',
    hexColor: '#F5F5DC',
  },
  black: {
    it: 'Nero',
    hexColor: '#000000',
  },
  brown: {
    it: 'Marrone',
    hexColor: '#964B00',
  },
  burgundy: {
    it: 'Borgogna',
    hexColor: '#800020',
  },
  'dark beige': {
    it: 'Beige Scuro',
    hexColor: '#D2B48C',
  },
  'dark brown': {
    it: 'Marrone Scuro',
    hexColor: '#654321',
  },
  'dark burgundy': {
    it: 'Borgogna Scuro',
    hexColor: '#5D001E',
  },
  'dark charcoal': {
    it: 'Antracite Scuro',
    hexColor: '#333333',
  },
  'dark gray': {
    it: 'Grigio Scuro',
    hexColor: '#A9A9A9',
  },
  'dark green': {
    it: 'Verde Scuro',
    hexColor: '#006400',
  },
  'dark navy blue': {
    it: 'Blu Navy Scuro',
    hexColor: '#000080',
  },
  'deep purple': {
    it: 'Viola Intenso',
    hexColor: '#673AB7',
  },
  'dusty rose': {
    it: 'Rosa Antico',
    hexColor: '#DCAE96',
  },
  gray: {
    it: 'Grigio',
    hexColor: '#808080',
  },
  ivory: {
    it: 'Avorio',
    hexColor: '#FFFFF0',
  },
  'navy blue': {
    it: 'Blu Navy',
    hexColor: '#003F87',
  },
  purple: {
    it: 'Viola',
    hexColor: '#800080',
  },
  'sage green': {
    it: 'Verde Salvia',
    hexColor: '#87A96B',
  },
  taupe: {
    it: 'Tortora',
    hexColor: '#483C32',
  },
  white: {
    it: 'Bianco',
    hexColor: '#FFFFFF',
  },
};
